import { useEffect, useRef } from 'react';
import { SessionState } from 'sip.js';
import { useSipCall } from '@/shared/providers/SipCallProvider';
import { useBackendPhonePause } from './useBackendPhonePause';
function isVoiceSessionActive(incomingRing, conversationUi) {
    if (incomingRing !== null)
        return true;
    if (conversationUi === null)
        return false;
    return conversationUi.sipState !== SessionState.Terminated;
}
/**
 * After any voice leg ends (answer then hangup, decline, remote BYE before answer, outbound cancel),
 * refetch `GET /api/users/profile` for `isPhonePause` / `phonePauseEnd` so the toolbar shows ACW
 * or idle based on the PBX. Complements {@link sessionManagerDelegate} `onVoiceSessionEnded`.
 */
export function useSyncAcwAfterVoiceSessionEnd() {
    const { incomingRing, conversationUi } = useSipCall();
    const { syncAcwFromProfileAfterHangup } = useBackendPhonePause();
    const wasVoiceBusyRef = useRef(false);
    useEffect(() => {
        const voiceBusy = isVoiceSessionActive(incomingRing, conversationUi);
        if (wasVoiceBusyRef.current && !voiceBusy) {
            syncAcwFromProfileAfterHangup();
        }
        wasVoiceBusyRef.current = voiceBusy;
    }, [incomingRing, conversationUi, syncAcwFromProfileAfterHangup]);
}
